export default __webpack_public_path__ + "static/media/cardbacktr.036eb068.png";